import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import ReportsDashboard from "../../main/reports/reportsDashboard/page";
import AllReports from "../../main/reports/allReports/page";
import ExportHistory from "../../main/reports/exportHistory/page";
import ReportsSchedule from "../../main/reports/schedule/page";

const reportsRoute = [
  {
    path: "", // Relative to parent /reports → /reports
    element: <ReportsDashboard />,
    module: "reports",
    submodule: "dashboard",
    bypass: [0, 1], // Super Admin & Workspace Admin
  },
  // Specific report routes (matching menuConfig submodules)
  {
    path: "payroll-cost",
    element: <AllReports />,
    module: "reports",
    submodule: "payroll", // Must match menuConfig
    bypass: [0, 1],
  },
  {
    path: "attendance-summary",
    element: <AllReports />,
    module: "reports",
    submodule: "attendance", // Must match menuConfig
    bypass: [0, 1],
  },
  {
    path: "leave-trends",
    element: <AllReports />,
    module: "reports",
    submodule: "leave", // Must match menuConfig
    bypass: [0, 1],
  },
  {
    path: "reimbursement-spend",
    element: <AllReports />,
    module: "reports",
    submodule: "reimbursement", // Must match menuConfig
    bypass: [0, 1],
  },
  {
    path: "headcount-attrition",
    element: <AllReports />,
    module: "reports",
    submodule: "headcount", // Must match menuConfig
    bypass: [0, 1],
  },
  {
    path: "export-history",
    element: <ExportHistory />,
    module: "reports",
    submodule: "dashboard",
    bypass: [0, 1],
  },
  {
    path: "schedule",
    element: <ReportsSchedule />,
    module: "reports",
    submodule: "dashboard",
    bypass: [0, 1],
  },
];

export default function renderReportsRoutes() {
  const renderRoute = (route, access = false) => {
    // Handle index route (empty path)
    const routeProps = route.path === "" 
      ? { index: true } 
      : { path: route.path };
    
    return (
      <Route
        key={route.path || "index"}
        {...routeProps}
        element={
          access ? (
            route.element
          ) : (
          <ProtectedRoute
            module={route.module}
            submodule={route.submodule}
            path={route.path || "/reports"}
          >
            {route.element}
          </ProtectedRoute>
          )
        }
      />
    );
  };

  return reportsRoute.map((route) => renderRoute(route));
}

